import { FlatTreeControl } from '@angular/cdk/tree';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
//import { NgwWowService } from 'ngx-wow';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-home',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {

  projectList: any = [];
  territoryList: any = [];
  roleList: any = [];
  pwmUserId: number = 543;
  selectedProjectId: number = 0;
  selectedSubgroupId: number = 0;
  selectedRoleId: number = 0;

  constructor( public _commonService: CommonService,
    private router: Router, private authService: AuthService, private dataService: DataService) {
    //wowService.init();
  }

  ngOnInit(): void {
    this.getAuthorizedData();
  }

  getAuthorizedData() {

    this.projectList = [];
    // let params = new HttpParams();
    // params = params.append("userId", this.pwmUserId);

    // this.dataService.getData("Projects", params, this.dataService.apiURL_JAVA).subscribe(res => {
    //   if (res != null) {
    //     if (res.data.length > 0) {
    //       for (var i = 0; i < res.data.length; i++) {
    //         if (!this.projectList.find(x => x.projectId == res.data[i].PROJECT_ID)) {
    //           this.projectList.push({ projectId: res.data[i].PROJECT_ID, projectName: res.data[i].PROJECT_NAME });
    //         }
    //       }
    //       // this.selectedProjectId = this.projectList[0].projectId;
    //       // this.getSubgroups(this.selectedProjectId);
    //     }
    //   }
    // });
  }

  getSubgroups(projectId: number) {

    this.selectedProjectId = projectId;
    this.territoryList = [];

    if (projectId == undefined || projectId == null || Number(projectId) == 0) {
      return;
    }

    // let params = new HttpParams();
    // params = params.append("projectId", projectId);

    // this.dataService.getData("Subgroups", params, this.dataService.apiURL_JAVA).subscribe(res => {
    //   if (res != null) {
    //     if (res.data.length > 0) {
    //       res.data.forEach(x => {
    //         this.territoryList.push({ territoryId: x.SUBGROUP_ID, territoryName: x.BUSINESSUNIT, logo: '/assets/img/country.png' });
    //       });
    //       // this.selectedSubgroupId = this.territoryList[0].territoryId;
    //       // this.getRoles(this.selectedSubgroupId);
    //     }
    //   }
    // });

  }

  getRoles(territoryId: number) {

    this.selectedSubgroupId = territoryId;
    this.roleList = [];

    if (territoryId == undefined || territoryId == null || Number(territoryId) == 0) {
      return;
    }

    // let params = new HttpParams();
    // params = params.append("projectId", this.selectedProjectId);
    // params = params.append("userId", this.pwmUserId);

    // this.dataService.getData("Roles", params, this.dataService.apiURL_JAVA).subscribe(res => {
    //   if (res != null) {
    //     if (res.data.length > 0) {
    //       res.data.forEach(x => {
    //         this.roleList.push({ roleId: x.ROLE_ID, roleName: x.ROLE_NAME });
    //       });
    //     }
    //   }
    // });
  }

  onSelectRole(roleId: any) {
    this.selectedRoleId = roleId;
    this.router.navigate(['/control-panel']);
  }

}
